export default "__VITE_ASSET__DwkXMI0I__"